import {css, StyleSheet} from 'aphrodite';
import moment from 'moment';
import React from 'react';

import KeyValueTooltip from 'notebook/entry-templates/SelectTemplateCollectionItemTree/KeyValueTooltip';
import {SelectTemplateCollectionItem} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/types';
import {SILVER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const ModifiedAtIcon = ({item}: {item: SelectTemplateCollectionItem}): JSX.Element => (
  <KeyValueTooltip
    keyText="Last modified"
    valueText={item.modifiedAt ? moment(item.modifiedAt).format('M/D/YYYY hh:mm A') : ''}
  >
    <BenchlingIcon className={css(styles.modifiedAtIcon)} icon="clock" />
  </KeyValueTooltip>
);

const styles = StyleSheet.create({modifiedAtIcon: {color: SILVER}});

export default ModifiedAtIcon;
